module.exports = __webpack_public_path__ + "img/cooperative0_logo25.343682a8.jpg";